import { render, staticRenderFns } from "./CreateFixedAssetInternal.vue?vue&type=template&id=12180ea0"
import script from "./CreateFixedAssetInternal.vue?vue&type=script&lang=js"
export * from "./CreateFixedAssetInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports